import { Layout } from "react-admin";
import CustomAppBar from "./AppBar";
import Menu from "./Menu";


export const layout = (props) => {
    return <Layout {...props} appBar={CustomAppBar} menu={Menu} />;
};